/** @format */

import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { CommonWidgetsModule } from '../../../common-widgets/common-widgets.module';
import { FullStoryWMovingCopyBoxComponent } from './full-story-w-moving-copy-box.component';
import { MediaModule } from '@shared/media/components';
import { NoBackgroundDirective } from '@shared/utils/directives';
import { WindowModule } from '@shared/data-access/services';

@NgModule({
	imports: [CommonModule, CommonWidgetsModule, MediaModule, NoBackgroundDirective, WindowModule],
	declarations: [FullStoryWMovingCopyBoxComponent],
	bootstrap: [FullStoryWMovingCopyBoxComponent],
	exports: [FullStoryWMovingCopyBoxComponent],
	providers: [],
	schemas: [NO_ERRORS_SCHEMA]
})
export class FullStoryWMovingCopyBoxModule {}
